import BillGateHome from "./BillGateHome";

export default BillGateHome;

